import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { AppConfigService } from 'src/app/app-config.service.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import { PipelineService } from 'src/app/services/pipeline.service';
import { ProjectService } from 'src/app/services/project.service';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { SalesleadService } from 'src/app/services/saleslead.service';
import { TaskService } from 'src/app/services/task.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { FormControl, FormGroup } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { ContactService } from 'src/app/services/contact.service';
import CustomStore from 'devextreme/data/custom_store';
import { NewCustomerComponent } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.component';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'dinamic-modal',
  templateUrl: './dinamic-modal.component.html',
  styleUrls: ['./dinamic-modal.component.scss']
})
export class DinamicModalComponent implements OnInit, OnChanges  {
  @Input() popupUtilityTable: any
  @Input() EditDe: any;
  @Input() popupActivityType: any
  @Output() infoDeRegreso = new EventEmitter();
  @Output() resultado = new EventEmitter();
  @Input() popupUtilityTableVertical: any;
  @Input() popupaddProdSpeButtonNOTBIDREASON: any;
  @Input() popupLeadStatus: any;
  @Input() popupaddFollowleadSatatus: any;
  @Input() popupMarketCampaign: any;
  @Input() modalCustomerContacts: any;
  @Input() projectid: any;
  @Input() ModalDinamico: any;
  @Input() ServiceInsert: any;
  @Input() ServiceGet: any;
  @Input() nombreDinamico: any;

  @Input() serviceToSave: any;
  @Input() serviceToDelete: any;
  @Input() serviceGet: any;
  @Input() idField: any;
  @Input() nameField: any;
  @Input() idFieldSaveOrModify: any;
  @Input() nameFieldSaveOrModify: any; 
  @Input() openUtilityReu:boolean
  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;
  @ViewChild("newCustomerSelect", { static: false }) newCustomerSelect: DxSelectBoxComponent;
  @ViewChild("newContactsSelect", { static: false }) newContactsSelect: DxSelectBoxComponent;


  // Sort, description, name y id

  @Input() popupGenerar: boolean;
  @Input() sortField: any;
  @Input() descriptionField: any;
  @Input() sortFieldSaveOrModify: any;
  @Input() descriptionFieldSaveOrModify: any;



  modalCustomer:any="New Contact"


  dateFormat:any
  formatCurrency:any
  optionsCType:any
  projectCategorySelect:any
  events: Array<string> = [];
  verticalMarketSelect:any
  notBidReasonSelect:any
  optionsSalesLeadStatus:any=[]
  allStatusSales2:any[]=[]
  allSalesLeadFollowUpStatus:any[]=[]
  optionsMarketingCampaign:any[]=[]
  enabeleCustomerContacts:boolean=false
  popupNewContact:boolean=false
  dataCustomerContacts:any[]=[]
  customerForm: FormGroup;
  selectedContact:any
  selectedCustomer:any
  customersList:any[]=[]
  contactDataSource:any
  participantType:any
  customerType:any
  infoGridDinamico:any[]=[]
  popupCustomer2:boolean=false
  addCustomerButton:any
  cancelButtonNewCustomer:any

  saveButtonNewCustomer:any
  addRequestByButton:any
  popupNewContactCustomer:boolean=false


  constructor(
    private salesProjectService: SalesProjectService,
    private pipeDate: DatePipe,
    private projectService: ProjectService,
    private toast: ToastService,
    private generalService: GeneralService,
    private customerService: CustomerService,
    private taskService: TaskService,
    private pipelineService: PipelineService,
    private datePipe: DatePipe,
    private router: Router,
    public appConfigService: AppConfigService,
    private activatedRoute: ActivatedRoute,
    public MapInformationService:MapInformationService,
    private salesLeadService: SalesleadService,
    private contactService: ContactService,
    private translate:TranslateService
  ) {
    this.dateFormat = this.appConfigService.dateFormat
    this.formatCurrency = {style: 'currency', currency: this.appConfigService.moneyFormat}

    let moneyTableFormat = this.appConfigService.moneyFormat;
    if (this.appConfigService.moneyFormat == '$') { moneyTableFormat = 'USD' }

    this.formatCurrency = { style: 'currency', currency: moneyTableFormat }

    this.addCustomerButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer2 = true;
      },
    };

    this.cancelButtonNewCustomer = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.closeModalCustomer()
      },
    };

    this.saveButtonNewCustomer = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
      // disabled:this.newcustomer._formEntity.value.customername == ""
    };

    this.addRequestByButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupNewContactCustomer = true;
      },
    };

  }

  dataUtility:any[]=[]

  ngOnInit() {
    switch (this.EditDe){
      case "Activity Type":
        this.getInfoActivity()
        break
      case "Utility Tables":
        this.getProjectCategory()
        break
      case "Vertical Market":
        this.getProjectVerticalMarket()
        break
      case "Not Bid Reason":
        this.getProjectNotBidReason()
        break
      case "leads Status":
        this.getSalesleadsStatus()
        break
      case "Follow Up Status":
        this.getFollowupStatus()
        break
      case "Marketing Campaign":
        this.getMarketingCampaign()
        break
      case 'modalCustomerContacts':
        this.initCustomerForm()
        this.getCustomers()
        this.getContactsCustomer()
        this.getParticipantType()
        this.getContactsType()
        this.getInfoCustomerContacts()

        this.enabeleCustomerContacts = true
        break
      case "Unico":
        this.getinfo()
        break
    }

    this.getUtilityTable()

  }

  
  ngOnChanges(changes: SimpleChanges): void {
   this.ngOnInit()
  }


  // *************************** Modales para insertar o editar registros de select ***********************************

  // sales Activity type

  getInfoActivity(){
    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err)
      }
    )
  }

  InsertNew(event){
    console.log(event)
    const data = {
      method:"InsertUpdate_ActivityType",
      id:0,
      name:event.data.label,
      sort:"",
      active:1
    }
    console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Activity Type added Successfully")
      this.getInfoActivity()
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)
      this.popupActivityType = false
    })
  }

  UpdateNorReasonNew(event){
    const data = {
      method:"InsertUpdate_ActivityType",
      id:event.data.value,
      name:event.data.label,
      sort:"",
      active:1
    }
    console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Activity Type updated Successfully")
      this.getInfoActivity()
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)
    })
  }

  // Utility tables Category

  getProjectCategory() {
    this.salesProjectService.GetProjectSalesCategory().subscribe(result => {
      // this.salesCategorySelect = result.map((val) => {
      //   return { // Return the new object structure
      //     label: val.PROJECTSLSCATEGORY,
      //     value: val.ID
      //   };
      // });
      this.projectCategorySelect = result;
    });
  }

  insertUpdateProjectCategory(ev) {
    console.log(ev);
    let model = {
      id: 0,
      projectslscategory : '',
      sort:0,
      active:1,
      method:"Estimates_InsertUpdate_ProjectSalesCategory"
    };

    model.sort = 0;
    model.active = 1;

    if (ev.data) {
      model.id = 0;
      model.projectslscategory = ev.data.PROJECTSLSCATEGORY;
    } else if (ev.newData) {
      model.id = ev.key;
      model.projectslscategory = ev.newData.PROJECTSLSCATEGORY;
    }

    console.log(model)
    console.log(this.projectCategorySelect)
    this.MapInformationService.SaveInfoSites(model).subscribe(result => {
    // this.salesProjectService.InsertUpdateSalesCategory(model).subscribe(result => {
      console.log(result)
      this.resultado.emit(result);
      this.getProjectCategory();
      // this.infoDeRegreso.emit(false)
    })
  }

  onCellPrepared(ev) { }

  logEvent(eventName) {
    this.events.unshift(eventName);
  }


  // Vertical Market

  getProjectVerticalMarket() {
    this.salesProjectService.GetProjectVerticalMarket().subscribe(result => {
      this.verticalMarketSelect = result;
    });
  }

  InsertUpdateVerticalMarket(ev) {
    console.log(ev);
    let model = {
      id: 0,
      verticalmarketdescription: ''
    };
    if (ev.data.ID && ev.data.ID > 0) {
      model.id = ev.data.ID;
    }

    model.verticalmarketdescription = ev.data.VERTMARKETDESCRIPTION;

    this.salesProjectService.InsertUpdateVerticalMarket(model).subscribe(result => {
      console.log('nitido', result);
      this.getProjectVerticalMarket();
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(result)
    });
  }

  closeModal(){
    this.infoDeRegreso.emit(false)
  }

  // Not Bid Reasons

  getProjectNotBidReason() {
    this.salesProjectService.GetProjectNotBidReason().subscribe(result => {
      this.notBidReasonSelect = result;
    });
  }

  InsertNewNotBidReasons(event){
    console.log(event)
    const data = {
      method:"InsertUpdate_SalesNotBidReason",
      id:0,
      name:event.data.NAME,
      sort:"",
      active:1
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Not Bid Reason added Successfully")
      this.getProjectNotBidReason()
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)
    })
  }

  UpdateNotBidReasons(event){
    const data = {
      method:"InsertUpdate_SalesNotBidReason",
      id:event.data.ID,
      name:event.data.NAME,
      sort:"",
      active:1
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Not Bid Reason updated Successfully")
      this.getProjectNotBidReason()
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)
    })
  }


  InsertNewdinamic(event){
    console.log(event)
    const data = {
      method:"Save_MasterDepartments",
      [this.idFieldSaveOrModify]:0,
      [this.nameFieldSaveOrModify]:event.data[this.nameField],
      [this.sortFieldSaveOrModify]:event.data[this.sortField],
      [this.descriptionFieldSaveOrModify]:event.data[this.descriptionField],
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Created Successfully")
      this.getUtilityTable()
      // this.infoDeRegreso.emit(false)
      // this.resultado.emit(resp)
    })
  }

  Updatedinamic(event){
    console.log(event)
    console.log(this.idFieldSaveOrModify, this.idField)
    console.log(this.sortFieldSaveOrModify, this.sortField)
    console.log(this.descriptionFieldSaveOrModify, this.descriptionField)
    const data = {
      method:"Save_MasterDepartments",
      [this.idFieldSaveOrModify]:event.data[this.idField],
      [this.nameFieldSaveOrModify]:event.data[this.nameField],
      [this.sortFieldSaveOrModify]:event.data[this.sortField],
      [this.descriptionFieldSaveOrModify]:event.data[this.descriptionField],
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Updated Successfully")
      this.getUtilityTable()
      // this.infoDeRegreso.emit(false)
      // this.resultado.emit(resp)
    })
  }


  // leads Status
  getSalesleadsStatus(){
    let data2 = {
      method:"Get_ProjectSalesLeadStatusEdit"
    }
    this.MapInformationService.SaveInfoSites(data2)
    .subscribe(info1=>{
      this.allStatusSales2 = info1
    })
  }

  save_edit(event) {
    let item = event.data;
    console.log(item)
    console.log(event)
    let contador = 0

    if(item.STATUS == undefined){
      this.toast.warning("Required Name")
      contador++
    } else if (item.SORT == undefined){
      // this.toast.warning("Required Sort")
      item.SORT = 0
      // contador++
    }

    if (item.ACTIVE == undefined){
      item.ENABLE = 0
    }


    if(contador == 0){
      const data = {
        id:0,
        name:item.STATUS,
        sort:item.SORT,
        active:item.ACTIVE == true ? 1:0,
        method:"Insert_SalesLeadStatus",
        statusdescription: item.LEADSTATUSDESCIPTION,
      }
      console.log(data)

      this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        this.toast.success("Successfully Created")
        // this.infoDeRegreso.emit(false)
        this.resultado.emit(resp)
      })
    }

  }

  update(obj) {
    let olddata = obj.oldData;
    let newData = obj.newData;
    let item = obj.newData

    if(item.STATUS == undefined){
      item.STATUS = olddata.STATUS
    }

    if (item.SORT == undefined){
      item.SORT = olddata.SORT
    }

    if (item.ACTIVE == undefined){
      item.ACTIVE = olddata.ACTIVE
    }

    if (item.LEADSTATUSDESCIPTION == undefined){
      item.LEADSTATUSDESCIPTION = olddata.LEADSTATUSDESCIPTION
    }

    const data = {
      id:olddata.ID,
      name:item.STATUS,
      sort:item.SORT,
      active:item.ACTIVE == true ? 1:0,
      method:"Update_SalesLeadStatus",
      statusdescription: item.LEADSTATUSDESCIPTION,
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp => {
      this.toast.success("Successfully updated")
      // this.infoDeRegreso.emit(false)
      this.resultado.emit([{ID:data.id}])
    })

  }

  // follow up status
  getFollowupStatus(){
    let data2 = {
      method:"Get_ProjectSalesLeadFUpStatusEdit"
    }
    this.MapInformationService.SaveInfoSites(data2)
    .subscribe(resp=>{
      this.allSalesLeadFollowUpStatus = resp
    })
  }

  save_edit_FollowUpStatus(event){
    let item = event.data;
    let contador = 0

    if(item.STATUS == undefined){
      this.toast.warning("Required Name")
      contador++
    } else if (item.SORT == undefined){
      // this.toast.warning("Required Sort")
      // contador++
      item.SORT = 0
    }

    if (item.ACTIVE == undefined){
      item.ENABLE = 0
    }


    if(contador == 0){
      const data = {
        id:0,
        name:item.STATUS,
        sort:item.SORT,
        active:item.ACTIVE == true ? 1:0,
        method:"Insert_SalesLeadFollowUpStatus"
      }

      this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        this.toast.success("Successfully Created")
        // this.infoDeRegreso.emit(false)
        this.resultado.emit(resp)
      })
    }
  }

  update_FollowUpStatus(obj){
    let olddata = obj.oldData;
    let newData = obj.newData;
    let item = obj.newData

    if(item.STATUS == undefined){
      item.STATUS = olddata.STATUS
    }

    if (item.SORT == undefined){
      item.SORT = olddata.SORT
    }

    if (item.ACTIVE == undefined){
      item.ACTIVE = olddata.ACTIVE
    }

    const data = {
      id:olddata.ID,
      name:item.STATUS,
      sort:item.SORT,
      active:item.ACTIVE == true ? 1:0,
      method:"Update_SalesLeadFollowUpStatus"
    }
    console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp => {
      this.toast.success("Successfully updated")
      // this.infoDeRegreso.emit(false)
      this.resultado.emit([{ID:data.id}])
    })
  }

  getMarketingCampaign(){
    this.generalService.getPopulateGeneral('SalesLeadMarketingCampaign').subscribe(result => {
      this.optionsMarketingCampaign = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
    });
  }

  InsertMarketingCampaign(event){
    console.log(event)
    const data = {
      id:0,
      name:event.data.label,
      method:"InsertUpdateMarketingCampaign"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("The Marketing Campaign was saved successfully")
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)
    })
  }

  UpdateMarketingCampaign(event){
    console.log(event)
    const data = {
      id:event.data.value,
      name:event.data.label,
      method:"InsertUpdateMarketingCampaign"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("The Marketing Campaign was updated successfully")
      // this.infoDeRegreso.emit(false)
      this.resultado.emit(resp)

    })
  }



  // *************************** Funciones para componentes que seran reutilizable ***********************************

  // Customer Contacts (edit sales leads y edit Project)

  initCustomerForm() {
    // console.clear()
    this.customerForm = new FormGroup({
      customerid: new FormControl('', []), //901
      participanttypeid: new FormControl('', []),
      contactid: new FormControl('', []), //904957
      contacttypeid: new FormControl('', []),
      projectid: new FormControl(this.projectid, []),
      id: new FormControl(0, []),
    })
    this.selectedCustomer = '';
    this.selectedContact = '';
    this.popupNewContact=false;
    this.customerDataSource = []
    this.contactDataSource= []
    if (this.newCustomerSelect != undefined){
      this.newCustomerSelect.placeholder = "Select..."
    }

    if (this.newContactsSelect != undefined){
      this.newContactsSelect.placeholder = "Select..."
    }

    this.modalCustomer= "'ModuleEditSalesProj.titleNContact' | translate";
  }

  getInfoCustomerContacts(){
    console.log(this.projectid)
    this.projectService.GetCustomerContactList(this.projectid).subscribe(result => {
      console.log('Customer Contacts', result);
      this.dataCustomerContacts = result;
    })
  }

  selectCustomer(e) {
    if (e.selectedItem.ID != undefined) {
      this.customerForm.get('customerid').setValue(e.selectedItem.ID);
      this.selectedCustomer = e.DESCRIPTION;
    }
  }

  updateContactId(item) {
    if (item.selectedItem.ID != undefined) {
      this.customerForm.get('contactid').setValue(item.selectedItem.ID);
      this.selectedContact = item.selectedItem.ContaNameID;
    }
  }

  saveContact() {
    let form = this.customerForm.value;
    console.log(form);
    this.projectService.InsertUpdateCustomer(form).subscribe(result => {
      this.toast.success(this.translate.instant('msgCustSavSucc'));
      this.popupNewContact = false;
      this.getInfoCustomerContacts();
      this.initCustomerForm();
      this.selectedCustomer = '';
      this.selectedContact = '';
    })
  }

  getCustomers() {
    this.projectService.GetCustomers().subscribe(result => {
      this.customersList = result;
    })
  }


  getContactsCustomer() {
    let mythis = this;
    // this.contactDataSource = new DataSource({
    //   load: function (loadOptions: any) {
    //     return mythis.contactService.GetContactByName(loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });
  }

  getParticipantType() {
    this.projectService.GetCustomerParticipantType().subscribe(result => {
      this.participantType = result;
    })
  }

  getContactsType() {
    // this.projectService.GetCustomerContactType().subscribe(result => {
    this.projectService.GetCustomerContactTypeAll().subscribe(result => {
      console.log('Type ', result);
      this.customerType = result;
    })
  }



  /**Modal dinamico */
  getinfo(){

    this.MapInformationService.SaveInfoSites({method:this.ServiceGet})
    .subscribe(result=>{
      console.log()
      switch (this.nombreDinamico){
        case "Vendor":
          this.infoGridDinamico = result.map((val) => {
            return {
              label: val.Vendor_Name,
              value: val.ID
            };
          });
          break
        case "Status":
          this.infoGridDinamico = result.map((val) => {
            return {
              label: val.STATUS,
              value: val.ID
            };
          });
          break
        case "Shipping Method":
          this.infoGridDinamico = result.map((val) => {
            return {
              label: val.SHIPMETHOD,
              value: val.ID
            };
          });
          break
        case "Shipping Speed":
          this.infoGridDinamico = result.map((val) => {
            return {
              label: val.SHIPSPEED,
              value: val.ID
            };
          });
          break
          case "Field Tech":
            this.infoGridDinamico = result.map((val) => {
              return {
                label: val.CONTACTNAME,
                value: val.ID
              };
            });
            break
          case "Action Taken":
            this.infoGridDinamico = result.map((val) => {
              return {
                label: val.ACTIONTAKEN,
                value: val.ID
              };
            });
            break
            case "Fail Mode":
              this.infoGridDinamico = result.map((val) => {
                return {
                  label: val.FAILMODE,
                  value: val.ID
                };
              });
              break
            case "Inv Number for Credit":
              this.infoGridDinamico = result.map((val) => {
                return {
                  label: val.CUSTOMERTYPE,
                  value: val.ID
                };
              });
              break
      }
    })
  }

  InsertinfoDinamica(event){
    console.log(event)
    let data = {}
    switch (this.nombreDinamico){
      case "Vendor":
        data = {
          id:0,
          name:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Status":
        data = {
          id:0,
          status:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Shipping Method":
        data = {
          id:0,
          shipmethod:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Shipping Speed":
        data = {
          id:0,
          shipspeed:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Field Tech":
        data = {
          id:0,
          name:event.data.label,
          method:this.ServiceInsert
        }
        break
        case "Action Taken":
          data = {
            id:0,
            actiontaken:event.data.label,
            method:this.ServiceInsert,
            active:1
          }
        break
        case "Fail Mode":
        data = {
          id:0,
          failmode:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
        case "Inv Number for Credit":
        data = {
          id:0,
          name:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      // let resp = [{DebesIr:""}]
      this.toast.success("The Information was saved successfully")
      // this.infoDeRegreso.emit(false)
      resp[0].DebesIr = this.nombreDinamico
      this.resultado.emit(resp)
    })
  }

  UpdateinfoDinamica(event){

    let data = {}

    switch (this.nombreDinamico){
      case "Vendor":
        data = {
          id:event.data.value,
          name:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Status":
        data = {
          id:event.data.value,
          status:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Shipping Method":
        data = {
          id:event.data.value,
          shipmethod:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Shipping Speed":
        data = {
          id:event.data.value,
          shipspeed:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
      case "Field Tech":
        data = {
          id:event.data.value,
          name:event.data.label,
          method:this.ServiceInsert,
          active:1
        }
        break
        case "Action Taken":
          data = {
            id:event.data.value,
            actiontaken:event.data.label,
            method:this.ServiceInsert,
            active:1
          }
        break
        case "Fail Mode":
          data = {
            id:event.data.value,
            failmode:event.data.label,
            method:this.ServiceInsert,
            active:1
          }
        break
        case "Inv Number for Credit":
          data = {
            id:event.data.value,
            name:event.data.label,
            method:this.ServiceInsert,
            active:1
          }
        break
    }

    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      // let resp = [{DebesIr:""}]
      this.toast.success("The Information was updated successfully")
      resp[0].DebesIr = this.nombreDinamico
      this.resultado.emit(resp)

    })
  }

  customerDataSource:any

  OpenNewCustomerContacts(edit=null){
    let mythis = this
    this.customerDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_CustomerCE_ByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    if(edit == undefined){

      let contract = {
        method: "Get_ProjectServiceContractByID",
        projectid: this.projectid
      }
      let project = {
        method: "Get_ProjectByID",
        projectid: this.projectid
      }
      this.MapInformationService.SaveInfoSites(contract).subscribe(resultContract => {
    this.MapInformationService.SaveInfoSites(project).subscribe(resultProject => {
        if(resultContract.length > 0){
          console.log(resultContract)
          setTimeout(() => {
            this.newCustomerSelect.placeholder = resultContract[0].CoName
            // this.customerService.GetCustomerByName(resultContract[0].CoName).subscribe(data => {
              this.customerForm.get('customerid').setValue(resultContract[0].CUSTOMERID);
            // })
          }, 1000);
        }

        if(resultProject.length > 0){
          console.log(resultProject)
          setTimeout(() => {
            this.newCustomerSelect.placeholder = resultContract[0].CoName
            this.customerForm.get('customerid').setValue(resultContract[0].CUSTOMERID);
          }, 1000);
        }

      })
    })
    }
    this.modalCustomer="New Contact"
    this.popupNewContact = true;
  }

  close(){}

  closeModalCustomer(){
    this.popupCustomer2 = false;
  }

  getNewCustomer(ev){
    console.log(ev)
    // this.customerDataSource = []
    let mythis = this;
    this.customerForm.get('customerid').setValue(ev.id);
    // this.selectedCustomer = ev.name
    this.newCustomerSelect.placeholder = ev.name
    // this.newCustomerSelect.value = ev.name

    // this.customerDataSource = new CustomStore({
    //   key: "ID",
    //   useDefaultSearch: false,
    //   load: function (loadOptions: any) {
    //     if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
    //       loadOptions.searchValue = " "
    //     } else {
    //       loadOptions.searchValue = loadOptions.searchValue
    //     }
    //     return mythis.MapInformationService.GetAllInfoDinamico("Get_CustomerCE_ByName",loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         console.log(data);
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });
  }

  onsavecontact(ev) {
    console.log(ev)
    let obj = {
      selectedItem: {
        ID: ev.id,
        First: ev.First,
        Last: ev.Last
      }
    };

    this.customerForm.get('contactid').setValue(ev.id);
    this.newContactsSelect.placeholder = ev.First + ' ' + ev.Last;
    this.newContactsSelect.value = ev.id;
    // let mythis = this
    // this.contactDataSource = new CustomStore({
    //   key: "ID",
    //   useDefaultSearch: false,
    //   load: function (loadOptions: any) {
    //     if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
    //       loadOptions.searchValue = " "
    //     } else {
    //       loadOptions.searchValue = loadOptions.searchValue
    //     }
    //     return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         console.log(data);
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });

  }


  editContact(data){
    console.log(data)
    this.OpenNewCustomerContacts(true)

    this.customerForm.get("id").setValue(data.ID)

    this.customerForm.get("customerid").setValue(data.CustomerID)
    setTimeout(() => {
      this.newCustomerSelect != undefined ? this.newCustomerSelect.placeholder = data.CUSTOMERNAME : ""
      this.newContactsSelect != undefined ? this.newContactsSelect.placeholder = data.ContactName : ""
    }, 1000);


    this.customerForm.get("contactid").setValue(data.ContactID)
    this.customerForm.get("participanttypeid").setValue(data.PARTICIPANTTYPEID)
    this.customerForm.get("contacttypeid").setValue(data.CONTACTTYPEID)
    this.modalCustomer="Edit Contact"
  }


  DeleteContact(data){
    console.log(data)
    const info = {
      method:"Delete_ProjectParticipant",
      id:data.ID
    }

    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      this.toast.success("The record was successfully deleted")
      this.getInfoCustomerContacts()
    })
  }


  // popup dinamico
  getUtilityTable(){
    console.log('DInamico ', this.serviceGet);
    if(this.serviceGet){
      this.MapInformationService.SaveInfoSites({method:this.serviceGet})
      .subscribe(resp=>{
        this.dataUtility = resp
      }, err => {
        console.log('Err ', err);
      })
    }
  }
  
  closeModalopenUtilityReu(){
    this.openUtilityReu = false
    this.infoDeRegreso.emit()
  }

  insertInfoUtility(event){
    // console.log(event.data)
    // console.log(event.data['idField'])
    let data = {
      method:this.serviceToSave,
      [this.idFieldSaveOrModify]:0,
      [this.nameFieldSaveOrModify]:event.data[this.nameField],
    }
    console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      this.toast.success("The Information was saved successfully")
      this.getUtilityTable()
      // this.resultado.emit(resp)
    })
  }

  UpdateInfoUtility(event){

    let data = {
      method:this.serviceToSave,
      [this.idFieldSaveOrModify]:event.data[this.idField],
      [this.nameFieldSaveOrModify]:event.data[this.nameField],
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      this.toast.success("The Information was saved successfully")
      this.getUtilityTable()
    })
  }

  goEditCustomer(data){
    console.log(data)
    data.items[0].PROJECTID
    this.router.navigate(['/customers/editCustomer/', data.items[0].CustomerID])
  }

  redirectToFunction(data){
    console.log(data)
    this.router.navigate(['/contacts/editContact/', data.ContactID])
  }

}
